import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'shared/shared.module';
import { PimCatalogActionComponent } from './pim-catalog-action.component';
import { ExportReviewActionComponent } from './export-review-action.component';
import { ImportReviewAcesActionComponent } from './import-review-aces-action.component';
import { ImportReviewPiesActionComponent } from './import-review-pies-action.component';
import { PublishedCatalogActionComponent } from './published-catalog-action.component';
import { ViewExportActionComponent } from './view-export-action.component';
import { ContextualActionComponent } from './contextual-action.component';
import { ChangeStatusDropdownComponent } from './change-status-dropdown/change-status-dropdown.component';
import { ExportDropdownComponent } from './export-dropdown/export-dropdown.component';


@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    PimCatalogActionComponent,
    ExportReviewActionComponent,
    ImportReviewAcesActionComponent,
    ImportReviewPiesActionComponent,
    PublishedCatalogActionComponent,
    ViewExportActionComponent,
    ContextualActionComponent,
    ChangeStatusDropdownComponent,
    ExportDropdownComponent,
  ],
  exports: [
    PimCatalogActionComponent,
    ExportReviewActionComponent,
    ImportReviewAcesActionComponent,
    ImportReviewPiesActionComponent,
    PublishedCatalogActionComponent,
    ViewExportActionComponent,
    ContextualActionComponent,
    ChangeStatusDropdownComponent,
    ExportDropdownComponent,
   ],
  providers: []
})
export class ContextualActionModule {}
